import { event } from 'devextreme/events';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    FormControl,
    FormGroup,
    Validators,
    FormBuilder,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EnduserService } from 'src/app/services/enduser/enduser.service';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from 'src/app/services/setting/setting.service';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  @Input() props: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();


  public ngrating:any;
  public ngremark:any;
  public ratingData:any = [];
  public isBtnLoaded = false;
  checkExisit=true;
  public id: any;
  public starRating:any ;


  constructor( private ngbModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private enduserService: EnduserService,
    private settingService: SettingService,
    private toastr: ToastrService,
    private actRoute: ActivatedRoute

    ) {
      this.actRoute.paramMap.subscribe(params => {
        this.id = params.get('id');
        this.checkExisit =false;
      });
    }

  ngOnInit(): void {
  this.starRating = 0;
//   MTAsMTI
  }






  submit() {
    this.isBtnLoaded = true;
    const eid=atob(this.id);
        const did = eid.split(',');

    this.ratingData={enduser_id:did[1],order_id:did[0],rating:this.starRating,remarks:this.ngremark}

    if (this.ratingData) {


        this.enduserService.onSaveRating(this.ratingData).subscribe((res: any) => {
            if (res.success) {
                this.toastr.success(`${res.message}`);
                this.isBtnLoaded = false;
                this.starRating = 0;
                this.ngremark = '';
            } else {
                if (res.message) {
                this.isBtnLoaded = false;

                    this.toastr.error(`${res.message}`);
                } else {
                this.isBtnLoaded = false;

                    this.toastr.error(`Added Successfully`);
                }
            }
        },
        (err: any) => {
            this.toastr.error(`${err}`);
        },
        () => {
            this.isBtnLoaded = false;
        })
    }
    else {
        this.isBtnLoaded = false;

    }
}

}
